import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * USC Approved Assembly Catalog layout. Pure pass-through `<Outlet />`
 * wrapper so the per-page routes (`assemblies`, `manufacturers`,
 * `special-notices`, `shutoff-valves`, `detector-meters`) handle their
 * own breadcrumb + page-header layout. The shared sidebar lives one
 * level up (`_authenticated.tsx`) so this layer adds nothing visual —
 * it exists only to give TanStack Router a parent route to mount the
 * `/catalog/...` children under.
 */
export const Route = createFileRoute("/_authenticated/catalog")({
  component: CatalogLayout,
});

function CatalogLayout() {
  return <Outlet />;
}
